import axios from "axios";
import URL from "../api";
import {
  ADD_CRUSH_FAIL,
  ADD_CRUSH_REQUEST,
  ADD_CRUSH_SUCCESS,
  REMOVE_CRUSH_FAIL,
  REMOVE_CRUSH_REQUEST,
  REMOVE_CRUSH_SUCCESS,
} from "../types";
import { getProfileInfo } from "./profileActions";

export const addCrush = (crush) => async (dispatch, getState) => {
  try {
    const {
      Auth: { user },
    } = getState();
    dispatch({ type: ADD_CRUSH_REQUEST });
    // dispatch({ type: RESET_AUTH });
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user?.token,
      },
    };

    const { data } = await axios.put(URL + `/crushes/add`, { crush }, config);

    // localStorage.setItem("user_info", JSON.stringify(data));
    dispatch({ type: ADD_CRUSH_SUCCESS, payload: data });

    // update the state
    dispatch(getProfileInfo(user._id));
  } catch (error) {
    dispatch({
      type: ADD_CRUSH_FAIL,
      payload: error.response
        ? error.response.data
        : { errors: [{ msg: error.message }] },
    });
    console.log(error);
  }
};

export const removeCrush = (crush) => async (dispatch, getState) => {
  try {
    const {
      Auth: { user },
    } = getState();
    dispatch({ type: REMOVE_CRUSH_REQUEST });
    // dispatch({ type: RESET_AUTH });
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user?.token,
      },
    };

    const { data } = await axios.put(
      URL + `/crushes/remove`,
      { crush },
      config
    );

    // localStorage.setItem("user_info", JSON.stringify(data));
    dispatch({ type: REMOVE_CRUSH_SUCCESS, payload: data });
    dispatch(getProfileInfo(user._id));
  } catch (error) {
    dispatch({
      type: REMOVE_CRUSH_FAIL,
      payload: error.response
        ? error.response.data
        : { errors: [{ msg: error.message }] },
    });
    console.log(error);
  }
};
